import React from 'react';

import { styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StyledContainer = styled('div')`
    padding: 0.75rem;
`;

interface ErrorFormInterface {
    errorMessage: string;
}

const ErrorForm: React.FC<ErrorFormInterface> = ({ errorMessage }) => {
    const { t } = useTranslation('common');

    return (
        <StyledContainer>
            <Typography sx={{ margin: '0.75rem' }} variant='h6'>{t('somethingWentWrong')}</Typography>
            <Typography sx={{ margin: '0.75rem' }} variant="body1">{errorMessage}</Typography>
        </StyledContainer>
    );
};

export default ErrorForm;
